import actions from './actions';
import getters from './getters'
import mutations from './mutations';
import i18n from '../../../i18n';

const getDefaultState = () => ({
  dashboards : [
    {
      id:1,
      name:'sales-order-dashboard',
      code : 'salesOrder',
      configuration : {
        title : "",
        sales_reps : null,
        filters : {}, //les status seront ajouté aux filtres lors de la sélection
        criterias : [],
        customerClasses : [],
        productId : null
      },
      dialogSettings : {
        filters : true,
        sales_rep : {
          active : true,
          multiple : true
        },
        productId : {
          active : true,
          multiple :false
        },
        customerClasses : {
          active : true,
          multiple : true
        },
        inventories : {
          active : true,
          multiple : true
        },
        criterias : [
          {
            id:1,
            field : 'Date',
            code : 'date',
            operators : ['=', '>','<', '>=', '<='],
            selectedOperator : '=',
            values : ['Today','Yesterday'],
            selectedValue : 'Today'
          }
        ]
      }
    },
    {
      id:2,
      name : 'reservation-dashboard',
      code : 'reservation',
      dialogSettings : {
        filters : true,
        sales_rep : {
          active : true,
          multiple : true
        },
        productId : {
          active : true,
          multiple :false
        },
      },
      configuration : {
        filters: {
          productAvailable: true,
          productToCome: true,
          intent: true,
          completed: false,
          // active: true,
          // inactive: false,
          redFlag: false,
          yellowFlag: false,
          greenFlag: false},
        sales_reps : null,
        title : "",
        productId : null
        }
    },
    {
      id:3,
      name : 'invoice-dashboard',
      code:'invoice',
      configuration : {
        title : "",
        sales_reps : null,
        filters : {}, //les status seront ajouté aux filtres lors de la sélection
        criterias : [],
        customerClasses : [],
        fields : [],
        productId : null,
        },
      dialogSettings : {
        filters : true,
        sales_rep : {
          active : true,
          multiple : true
        },
        customerClasses : {
          active : true,
          multiple : true
        },
        productId : {
          active : true,
          multiple :false
        },
        fields : [
          'inv_number',
          'customer',
          'date',
          'due_date',
          'amount',
          'status',
          'payment',
          'paid_at'],
        criterias : [
          {
            id:1,
            field : 'Date',
            code : 'date',
            operators : ['=', '>','<', '>=', '<='],
            selectedOperator : '=',
            values : ['Today','Yesterday'],
            selectedValue : 'Today'
          },
          {
            id:2,
            field : 'Due date',
            code : 'due_date',
            operators : ['=', '>','<', '>=', '<='],
            selectedOperator : '=',
            values : ['Today','Yesterday'],
            selectedValue : 'Today'
          },
          {
            id:3,
            field : 'Paid at',
            code : 'paid_at',
            operators : ['=', '>','<', '>=', '<='],
            selectedOperator : '=',
            values : ['Today','Yesterday'],
            selectedValue : 'Today'
          },
          {
            id:4,
            field : 'Periode de grâce',
            code : 'delay',
            operators : ['=','>='],
            selectedOperator : '=',
            values : ['1','7','14','30','60','90'],
            selectedValue : '30'
          }
        ]
      }
    }
  ],
  dashboardToAdd : {
    id : null,
    name : null,
    configuration : {}
  },
  editingDashboardId: null
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
